import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Logout = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="logout icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M13.5618 5.54617C13.5602 5.129 13.7218 4.74005 14.0145 4.45069L14.1539 4.31282C14.4279 4.04098 14.7944 3.89014 15.1797 3.89014C15.5823 3.89014 15.9596 4.05298 16.2431 4.34883L22.6427 11.0742C23.1078 11.5617 23.1046 12.3523 22.638 12.8366L16.1006 19.6158C15.8202 19.9068 15.4445 20.0673 15.045 20.0673C14.6677 20.0673 14.3059 19.9214 14.03 19.656C13.7341 19.3705 13.5665 18.9832 13.5634 18.5654C13.5586 18.1482 13.717 17.758 14.0066 17.4651L17.8794 13.5808L6.86082 13.5808C5.9966 13.5808 5.29616 12.8635 5.29616 11.9786C5.29616 11.094 5.9966 10.3767 6.86082 10.3767H17.8445L14.0192 6.6397C13.7262 6.35196 13.5634 5.96301 13.5618 5.54617Z"
    />
    <path
      className={pathClass}
      d="M3.76091 5.4966V18.5035C3.76091 19.3908 3.12266 20.1099 2.33518 20.1099C1.54799 20.1099 0.909744 19.3908 0.909744 18.5035V5.4966C0.909744 4.60932 1.54799 3.8902 2.33518 3.8902C3.12266 3.8902 3.76091 4.60932 3.76091 5.4966Z"
    />
  </svg>
)
